import { render, staticRenderFns } from "./TagMinus.vue?vue&type=template&id=2313e08b"
import script from "./TagMinus.vue?vue&type=script&lang=js"
export * from "./TagMinus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports